import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {Observable} from 'rxjs/Observable';
import {HttpBase} from 'app/services/http-base.service';

type version = { compatible: boolean };

@Injectable()
export class CheckVersions extends HttpBase{
    constructor(http: HttpClient, router: Router, translateService: TranslateService){
        super(http, router, translateService);
    };

    GetVersion = (name: string, version: string): Observable<version> =>{
        return this.get<version>('/api/versions/checkversion', {params: {name, version}})
    };
}



// WEBPACK FOOTER //
// ./src/app/services/check-versions.service.ts